import { render } from "./SmallModal.vue?vue&type=template&id=7935cfad&scoped=true"
import script from "./SmallModal.vue?vue&type=script&lang=js"
export * from "./SmallModal.vue?vue&type=script&lang=js"

import "./SmallModal.vue?vue&type=style&index=0&id=7935cfad&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7935cfad"]])

export default __exports__